<template>
    <div class="chat-list-empty">
        <panel-background-icon :title="$t('common.chat')">
            <empty-chat></empty-chat>
        </panel-background-icon>
    </div>
</template>

<script>
    import EmptyChat from "../svg/EmptyChat";
    import PanelBackgroundIcon from "../../../common/PanelBackgroundIcon.vue"

    export default {
        name: "EmptyList",
        components: {EmptyChat, PanelBackgroundIcon}
    }
</script>